import { canUpgradeForReason } from "@zapier/upsells/esm/utils";
const toInfinity = (value) => value === -1 ? Number.MAX_SAFE_INTEGER : value;
const getPlanTypeWhere = (func, planStacks) => { var _a; return (_a = planStacks.find((planStack) => planStack.plans.find(func))) === null || _a === void 0 ? void 0 : _a.planType; };
export const getNextPlanTypeForUpgradeReason = ({ activeTrialType, currentPlan, planStacks, upgradeReason, }) => {
    if (planStacks.length === 0) {
        console.error("Property `planStacks` cannot be empty.");
        return undefined;
    }
    const planType = planTypeByUpgradeReason[upgradeReason]({
        currentPlan,
        planStacks,
        upgradeReason,
        activeTrialType,
    });
    if (planType) {
        return planType;
    }
    console.error(`Unable to find plan type for upgrade reason \`${upgradeReason}\`.`);
    return undefined;
};
const planTypeByUpgradeReason = {
    "email-support": () => "Starter",
    "live-zaps": ({ currentPlan, planStacks, upgradeReason }) => {
        if (!canUpgradeForReason({ plan: currentPlan, upgradeReason })) {
            return currentPlan.type;
        }
        return getPlanTypeWhere((plan) => toInfinity(plan.zapLimit) > currentPlan.zapLimit, planStacks);
    },
    multistep: ({ currentPlan, planStacks, upgradeReason }) => {
        if (!canUpgradeForReason({ plan: currentPlan, upgradeReason })) {
            return currentPlan.type;
        }
        return getPlanTypeWhere((plan) => plan.hasMultiStepZaps, planStacks);
    },
    paths: ({ currentPlan, planStacks, upgradeReason }) => {
        if (!canUpgradeForReason({ plan: currentPlan, upgradeReason })) {
            return currentPlan.type;
        }
        return getPlanTypeWhere((plan) => plan.hasPaths, planStacks);
    },
    premium: ({ currentPlan, planStacks, upgradeReason }) => {
        if (!canUpgradeForReason({ plan: currentPlan, upgradeReason })) {
            return currentPlan.type;
        }
        return getPlanTypeWhere((plan) => plan.hasPremiumApps, planStacks);
    },
    "premium-limit": ({ currentPlan, planStacks, upgradeReason }) => {
        if (!canUpgradeForReason({ plan: currentPlan, upgradeReason })) {
            return currentPlan.type;
        }
        return getPlanTypeWhere((plan) => plan.hasPremiumApps && plan.premiumAppsLimit === -1, planStacks);
    },
    tasks: ({ activeTrialType, currentPlan }) => activeTrialType ? activeTrialType : currentPlan.type,
    "tasks-low": ({ activeTrialType, currentPlan }) => activeTrialType ? activeTrialType : currentPlan.type,
};

// @zapier/upsells@8.0.3 (1de7a616e)
